import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'
import { allCategories } from 'app/mocks/data/users/categories'

import { api } from 'app/utils/constants'

import { Manager, ManagerPayload } from 'app/types/park/manager'

export const updateManager = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.managers.DETAILS}`,
    async ({ params, request }) => {
        const payload = await request.json()
        const { id } = params

        const payloadParsed = ManagerPayload.safeParse(payload)

        const managerFound = allManagers.find(
            (manager) => manager.id.toString() === id,
        )

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!managerFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        const categoryFound = allCategories.find(
            (category) => category.id === payloadParsed.data.category,
        )

        return HttpResponse.json<Manager>({
            ...managerFound,
            ...payloadParsed,
            category: categoryFound ?? managerFound.category,
        })
    },
)
